/**
 * External Dependencies
 */
import 'jquery';
import inViewport from "./util/inViewport";
import 'lity';
import "slick-carousel";


//Loading Animations
var animatedElement = document.querySelectorAll(".animate");
var viewPort = new inViewport();
var checkElements = function () {
  viewPort.checkInView(animatedElement);
};
window.addEventListener('scroll', checkElements, false);
window.addEventListener('load', checkElements, false);


$(() => {




  var toggleButton = document.querySelector(".navigation__toggle");
  var menuAttr = toggleButton.getAttribute("data-menu");
  var menu = document.querySelector(menuAttr);

  toggleButton.onclick = function () {
    //Toggle Button
    toggleButton.classList.toggle("navigation__toggle--open");

    //Toggle Menu
    menu.classList.toggle("navigation__list--open");
  };

  var el = document; // This can be your element on which to trigger the event
  var event = document.createEvent("HTMLEvents");
  event.initEvent("resize", true, false);
  el.dispatchEvent(event);

  window.addEventListener("resize", function () {
    if (window.innerWidth < 961) {
      menu.classList.remove("navigation__list--open");
      menu.classList.add("navigation__list--show");

    } else {

      menu.classList.add("navigation__list--open");
      menu.classList.add("navigation__list--hide");
    }
  });

  // var windowWidth = $(window).width();
  // $(window).resize(function() {
  //   if ($(window).width() != windowWidth) {
  //     windowWidth = $(window).width();
  //     if ($(window).width() > 961) {
  //       $(".navigation__list").css("display", "flex");
  //     } else {
  //       $(".navigation__list").css("display", "none");
  //       $(".navigation__toggle").removeClass("navigation__toggle-open");
  //     }
  //   }
  // });

  var accordion = $(".accordion-item-content");
  $.each(accordion, function (k, v) {
    $(v).hide();
  });
  //$(".accordion-item-content .accordion-item-content-first").show();
  $(".accordion-item-title").on("click", function (e) {
    $(this).toggleClass("button-active");
    $(this)
      .next("div")
      .slideToggle();
  });


  var sliders = document.querySelectorAll('.participating-schools__slider');
  sliders.forEach(function (slider) {
    $("#" + slider.id).slick({
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      arrows: true,
      autoplaySpeed: 4000,
      responsive: [{
        breakpoint: 480,
        settings: {
          arrows: false,
        },
      }, ],
    });
  });

  //Home Popup
  var homePage = document.querySelector('.home');
  var popupClose = document.getElementById('popup_close');
  var popup = document.querySelector('.popup__wrap');

  window.addEventListener('load', function (e) {
    if (homePage !== null) {

      var today = new Date();
      var expirationDate = today.getTime() + (86400000 * 30);
      var closed_cookie = localStorage.getItem('homepopup');
      var closed_date_cookie = localStorage.getItem('homepopup-date');

      if (closed_date_cookie && closed_cookie) {
        console.log(today.getTime());
        console.log(closed_date_cookie);
        
        
        
        if (today.getTime() > closed_date_cookie) {
          setTimeout(function () {
            popup.classList.add('active');
            homePage.classList.add('popupactive');
          }, 100);
        } 
        else {
          if (today < expirationDate) {
            popup.classList.remove('active');
            popup.classList.add('non-active');
          }
        }
      } else {
        popup.classList.add('active');
        homePage.classList.add('popupactive');
      }
    }
  });
  
  if (popupClose) {
    var video = document.querySelector('.popup__wrap');

    popupClose.addEventListener('click', function () {
      popup.classList.remove('active');
      homePage.classList.remove('popupactive');
      video.remove();

      //Set Cookie
      var tomorrow = new Date();
      localStorage.setItem("homepopup-date", tomorrow.getTime() + (86400000 * 365));
      localStorage.setItem("homepopup", true);
    });
  }

           //Banner
           function SiteBanner() {
            this.init = function(id) {
              //Get Banner
              var banner = document.getElementById(id);
        
              //Find Item from localStorage
              // var cookie = this.getItem(banner.id);
              // var date_cookie = this.getItem(banner.id + "-date");
        
              // if (cookie !== "true") {
              //   //Show Banner
              //   this.showBanner(banner.id);
              // } else {
              //   var today = new Date();
              //   if (today.getTime() > date_cookie) {
              //     this.showBanner(banner.id);
              //   }
              // }
            };
        
            // this.getItem = function(cookie) {
            //   return localStorage.getItem(cookie);
            // };
        
            this.setItem = function(item, value) {
              //var tomorrow = new Date();
              //localStorage.setItem(item + "-date", tomorrow.getTime() + 600000);
        
              //localStorage.setItem(item, value);
              var banner = document.getElementById(item);
              banner.classList.remove("site-banner--active");
            };
        
            // this.showBanner = function(id) {
            //   var banner = document.getElementById(id);
            //   banner.classList.add("site-banner--active");
            // };
          }
        
          //Show Banner if no localStorage cookie
          var bannerexists = document.getElementById("header-banner");
          if (bannerexists) {
            
            var myBanner = new SiteBanner();
            myBanner.init(bannerexists.id);
        
            var closeButton = bannerexists.querySelector('.site-banner-close');
            
        
            closeButton.addEventListener('click', function() {
              
              myBanner.setItem(bannerexists.id, true);
              let currentDate = new Date();
        
              // Calculate the expiration time (1 hour from now)
              let expirationTime = new Date(currentDate.getTime() + 60 * 60 * 1000); // Adding 1 hour in milliseconds
        
              // Convert expirationTime to UTC string format
              let expires = expirationTime.toUTCString();
              document.cookie = "headerbanner=hidden; expires=" + expires + "; path=/";
        
            });
        
            // //Hide Banner on click, set localStorage cookie
            // $(".site-banner-close").on("click", function() {
            //   var id = $(this)
            //     .parent()
            //     .attr("id");
            //   console.log(id);
            //   myBanner.setItem(id, true);
            //   //Resize parallax
            //   $(window)
            //     .trigger("resize")
            //     .trigger("scroll");
            // });
        
            //Hide Banner on click, set localStorage cookie
            // $("#" + bannerexists.id + " .button").on("click", function(e) {
            //   myBanner.setItem(bannerexists.id, true);
            //   var link = $(this).attr("href");
            //   if (link) {
            //     window.location.href = link;
            //   }
            //   e.preventDefault();
            // });
          }



});
